import { boxCollect } from '@/components/ElectronLayout/ElectronHead/popup/server';

export async function loginCollect(key?: any, data?: any) {
  if (key) boxCollect(loginCollectClass[key], data);
}

export const loginCollectClass = {
  // 主域名
  1658: 'zhuyuming_1658',
  // 备域名
  1659: 'beiyuming_1659',
  // 代理
  1660: 'dailifangwen_1660',
  // 设备打开登录界面
  1783: 'shebeiqidong_1783'
};
